






























































import Vue from "vue";
import { VueTableRequest, OrderApi } from "@/api";
import stateMixin from "@/mixins/state";

export default Vue.extend({
  data() {
    return {
      data: {},
      headers: [
        { text: "Afdeling", value: "facility" },
        {
          text: "Ontvangst bestand (uiterlijk)",
          value: "arrivalDay",
          align: "right"
        },
        { text: "Gereed voor transport", value: "shipmentDay", align: "right" }
      ],
      options: {
        sortBy: ["facility"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 100
      }
    };
  },
  name: "Calendar",
  mixins: [stateMixin],
  methods: {
    fetch: async function() {
      this.setState(this.states.LOADING);
      const api = new OrderApi();
      try {
        const request: VueTableRequest = {
          sortBy: this.options.sortBy,
          descending: this.options.sortDesc,
          page: this.options.page,
          rowsPerPage: this.options.itemsPerPage,
          search: ""
        };
        const { data } = await api.orderGetOrderFulfillmentSchedulesTable(
          request
        );
        this.data = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    }
  },
  watch: {
    options: {
      handler(val) {
        this.fetch();
      },
      deep: true,
      immediate: false
    }
  }
});
